module.exports = __webpack_public_path__ + "static/media/ganado.66f5b882.svg";